import { EntityStatus, YammerState, getStatus } from '../../state/types';

type GetMultiTenantOrganizationDetailsStatus = (state: YammerState) => EntityStatus;
export const getMultiTenantOrganizationDetailsStatus: GetMultiTenantOrganizationDetailsStatus = (state) =>
  getStatus(state.multiTenantOrganizationDetails);
